/* istanbul ignore file */
import { string as codecString } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const VerifyAssignmentDataParser = 
/* #__PURE__ */ parsers.object([['password', codecString]]);
export class VerifyAssignmentData extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return VerifyAssignmentDataParser.decode(input).map(res => new VerifyAssignmentData(res));
    }
    static unsafeDecode(input) {
        return VerifyAssignmentData.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return VerifyAssignmentDataParser.encode(data);
    }
    static schema() {
        return VerifyAssignmentDataParser.schema();
    }
}
